import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { delay, map } from 'rxjs/operators';

import * as NotificationActions from '../actions/notification.action';
import * as fromStore from '../reducers';

@Injectable()
export class NotificationEffects {
  constructor(
    private actions$: Actions,
    private store: Store<fromStore.AppState>
  ) {}

  @Effect()
  createThenRemoveNotification$ = this.actions$.pipe(
    ofType(NotificationActions.CREATE_NOTIFICATION),
    delay(3000),
    map((action) => {
      return new NotificationActions.RemoveNotification();
    })
  );
}
